module.exports = __webpack_public_path__ + "media/images/contact-party-84510ed0ff99e8fb7be6faa4a3cf1d28.png";